/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackLangViewModelPaginatedResponse } from "../types/FeedbackLangViewModelPaginatedResponse.ts";
import { feedbackLangViewModelSchema } from "./feedbackLangViewModelSchema.ts";

export const feedbackLangViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => feedbackLangViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<FeedbackLangViewModelPaginatedResponse>;
